const getLetterByIndex = (index: number): string => {
  const alphabet = "abcdefghijklmnñopqrstuvwxyz"
  if (index < 0 || index >= alphabet.length) {
    throw new Error("No existe letra para ese index")
  }
  return alphabet[index]
}

export default getLetterByIndex
